import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CircleBarIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Circle Bar`} {...props}>
    <G id="Icon/16px/Close-Small">
      <Circle
        id="Ellipse 247"
        cx="8"
        cy="8"
        r="6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <Path
        id="Vector 1"
        d="M6 8H10"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </G>
  </Icon>
);
